import React from 'react';
import clsx from 'clsx';
import type { NotificationSetting, NotificationCategory } from '@app-types';
import styles from './NotificationSidebar.module.css';

export interface NotificationSidebarProps {
  notifications: NotificationSetting[];
  selectedCode: string | null;
  hasChanges: boolean;
  onSelectNotification: (code: string) => void;
}

const CATEGORY_ORDER: NotificationCategory[] = ['evidence-collection', 'escalation', 'closure', 'other'];

const CATEGORY_LABELS: Record<NotificationCategory, string> = {
  'evidence-collection': 'Pending Evidence',
  escalation: 'Escalations',
  closure: 'Closure',
  other: 'Other'
};

const NotificationSidebar: React.FC<NotificationSidebarProps> = ({
  notifications,
  selectedCode,
  hasChanges,
  onSelectNotification
}) => {
  return (
    <aside className={styles.sidebar} data-test-id="notification-sidebar">
      <h2>Notifications</h2>
      {CATEGORY_ORDER.map((category) => {
        const items = notifications.filter((n) => n.category === category);
        if (items.length === 0) return null;

        return (
          <div key={category} className={styles.group} data-test-id={`notification-group-${category}`}>
            <h3 className={styles.groupTitle}>{CATEGORY_LABELS[category]}</h3>
            <ul className={styles.list}>
              {items.map((item) => (
                <li
                  key={item.code}
                  className={clsx(styles.item, selectedCode === item.code && styles.itemActive)}
                  data-test-id={`notification-item-${item.code}`}
                >
                  <button type="button" className={styles.itemButton} onClick={() => onSelectNotification(item.code)}>
                    <span className={styles.itemName}>{item.name}</span>
                    {item.is_modified && (
                      <span className={styles.modifiedDot} title="Modified from default" aria-label="Modified" />
                    )}
                    {item.code === selectedCode && hasChanges && (
                      <span className={styles.unsavedIndicator} title="Unsaved changes">
                        *
                      </span>
                    )}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        );
      })}
    </aside>
  );
};

export default NotificationSidebar;
